<form [formGroup]="updatePasswordForm" (ngSubmit)="onSubmit()" [hasUnsavedData]="updatePasswordForm">
  <button type="submit" hidden="hidden"></button>

  <div class="row">
    <div class="form-group row">
      <label class="col-4 col-form-label-sm" translate
      >EXTERNAL_ACCOUNT_LBL_PASSWORD</label
      >
      <div class="col">
        <div class="input-group position-relative">
        <input
          #password
          class="form-control form-control-sm input-eye"
          type="password"
          [placeholder]="''"
          formControlName="password"
          autocomplete="new-password"
          tabindex="2"
          checkFormFieldValidity
        />
          <span
            class="input-group-text position-absolute end-0 eye-sm"
            (click)="
            password.type = password.type === 'password' ? 'text' : 'password'
          "
            role="button"
            tabindex="0"
          >
          <i
            [class]="
              password.type === 'password'
                ? 'mdi mdi-eye-outline'
                : 'mdi mdi-eye-off-outline'
            "
          ></i>
        </span>
        </div>
      </div>
    </div>
  </div>
</form>
